export default function (state, data) {
    state.orders = [];
    data.AgreementList.forEach(i => {
        let item = i;
        data.AgreementsInStatuses.forEach(ii => {
            if (i.StatusID === ii.ST_ID) item.StatusColor = ii.Color;
        });
        item.ClientCurrency = item.ClientPrice ? item.ClientPrice.split(' ')[1] : '';
        item.ClientPrice = item.ClientPrice ? item.ClientPrice.split(' ')[0].replace(',', '.') * 1 : 0;
        item.OperatorCurrency = item.OperatorPrice?item.OperatorPrice.split(' ')[1]:'';
        item.OperatorPrice = item.OperatorPrice?item.OperatorPrice.split(' ')[0].replace(',', '.') * 1:0;
        state.orders.push(item);
    });
}